"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useAppEvents(query) {
  const { ...rest } = useElements("app-events", query);
  return {
    appEvents: rest.items,
    ...rest
  };
}

export { useAppEvents };
